const GC = window.__GENERATED_CONSTANTS__

export const reportUrls = GC.reportUrls
export const reportNameKeys = GC.reportNameKeys

// only used in next
export const TaskPredefinedFieldNames = {
    Deadline: 'Deadline',
    TypeOfWork: 'TypeOfWork',
}

export const NextGroupLevelId = {
   Project: 1,
   Customer: 0
}

export const NextWorkflowStatusColorKeyToClassicMap = {
    pink: 0,
    orange: 1,
    yellow: 2,
    light_green: 3,
    dark_green: 4,
    aquamarine: 5,
    blue: 6,
    violet: 7,
    light_gray: 8,
    dark_gray: 9,
}

export const ClassicWorkflowStatusColorKeyToNextMap = Object.fromEntries(Object
    .entries(NextWorkflowStatusColorKeyToClassicMap)
    .map((([key, value]) => [value, key]))
)

/**
 * !! Don't change value without corresponding change in next web
 */
export const AtNextCustomScrollbarUsedClassName = '_internal_atNextCustomScrollbarUsed'

export const ApiErrorKeys = {
    NotFoundEntity: 'not_found.entity',
    Unauthenticated: 'unauthenticated'
}

export const ApiEntityTypes = {
    CustomField: 'custom_field'
}



// WEBPACK FOOTER //
// ./web/js/next/constants.js